export const telephone = '01 81 80 45 23';
